<template>
  <div class="checkout-option-form">
    <div v-if="checkoutOption">
      <div class="form-group">
        <label>Label on Checkout Page</label>
        <input class="form-control" v-model="checkoutOption.label" />
      </div>
      <div class="form-group">
        <label>Field Type</label>
        <select class="form-control" v-model="checkoutOption.type">
          <option value="1">Checkbox</option>
          <option value="2">Text</option>
        </select>
      </div>
      <div class="form-group">
        <label>Fee ($)</label>
        <input class="form-control" v-model="checkoutOption.price" type="number" step="0.01" />
      </div>
      <div class="form-group">
        <label>Fee Type</label>
        <select class="form-control" v-model="checkoutOption.perItem">
          <option
            value="1"
          >Per-Node (charge the user this fee for each applicable node they are ordering)</option>
          <option
            value="2"
          >Per-Order (charge the user this fee once for the entire order, regardless of node count)</option>
        </select>
      </div>
      <transition name="fade">
        <div class="form-group node-type-picker" v-if="checkoutOption.perItem == 1">
          <label>Per-Node Fee: Applicable Node Types (for example, if the per-node fee is only valid for Panels, select Panels)</label>
          <div class="button-row">
            <button class="btn small-btn" @click="toggleAllNodeTypes()">Toggle All</button>
          </div>
          <hr />
          <div
            v-for="(type,i) in $consts.purchaseableNodeTypes"
            :key="`node-type-${i}`"
            class="node-type-row"
          >
            <input :id="type" type="checkbox" v-model="applicableNodeTypes[type]" />
            <label :for="type">{{$consts.NODE_LABELS_FOR_PATH_TYPE[type] }}</label>
          </div>
        </div>
      </transition>
      <div class="button-row form-group">
        <button class="btn" @click.prevent="onSubmit">Submit</button>
        <button v-if="checkoutOption.id" class="btn" @click.prevent="onDelete">Delete</button>
      </div>
    </div>
    <div v-else>No checkout option selected.</div>
    <error-panel class="m-auto" :errors="[error]"></error-panel>
  </div>
</template>

<script>
export default {
  name: "checkout-option-form",
  props: ["checkoutOption"],
  data() {
    // Initialize applicableNodeTypes
    const typesObj = this.initializeNodeTypes();
    return {
      isLoading: false,
      error: "",
      applicableNodeTypes: typesObj
    };
  },
  methods: {
    initializeNodeTypes() {
      let typesObj = {};

      // Apply nodeTypesJson field
      let enabledNodeTypes = [];
      if (this.checkoutOption.nodeTypesJson) {
        enabledNodeTypes = JSON.parse(this.checkoutOption.nodeTypesJson);
      }

      this.$consts.purchaseableNodeTypes.forEach(
        type =>
          (typesObj[type] = enabledNodeTypes.includes(
            this.$consts.NODE_TYPE_STR_TO_INT[type]
          ))
      );

      return typesObj;
    },
    toggleAllNodeTypes() {
      const val = !Object.keys(this.applicableNodeTypes).some(
        type => this.applicableNodeTypes[type]
      );
      for (let i = 0; i < Object.keys(this.applicableNodeTypes).length; i++) {
        const type = Object.keys(this.applicableNodeTypes)[i];
        this.applicableNodeTypes[type] = val;
      }
      this.$forceUpdate();
    },
    async onSubmit() {
      try {
        // validate
        if (
          !this.checkoutOption.type ||
          !this.checkoutOption.label ||
          !this.checkoutOption.perItem
        ) {
          this.error = "Type, Label, and Fee Type are required.";
          return;
        }

        // Arrange all applicable node types into an array, using their type ids to identify them
        let nodeTypesJson = null;
        if (this.checkoutOption.perItem == 1) {
          let nodeTypes = [];
          for (let i = 0; i < this.$consts.purchaseableNodeTypes.length; i++) {
            let type = this.$consts.purchaseableNodeTypes[i];
            if (this.applicableNodeTypes[type]) {
              nodeTypes.push(this.$consts.NODE_TYPE_STR_TO_INT[type]);
            }
          }
          if (!nodeTypes.length) {
            this.error =
              "At least one node type is required for the Per-Node Fee Type";
            return;
          }
          nodeTypesJson = JSON.stringify(nodeTypes);
        }

        if (this.checkoutOption.id) {
          await this.$web.editCheckoutOption({
            id: this.checkoutOption.id,
            type: this.checkoutOption.type,
            label: this.checkoutOption.label,
            price: this.checkoutOption.price,
            perItem: this.checkoutOption.perItem,
            nodeTypesJson
          });
        } else {
          const response = await this.$web.createCheckoutOption({
            type: this.checkoutOption.type,
            label: this.checkoutOption.label,
            price: this.checkoutOption.price,
            perItem: this.checkoutOption.perItem,
            nodeTypesJson
          });

          this.$store.commit("addCheckoutOption", response.data.newOption);
        }

        this.$emit("clearSelected");
      } catch (e) {
        console.log("Error: ", e);
        this.error = "An error occurred.";
      }
    },
    async onDelete() {
      try {
        await this.$web.deleteCheckoutOption({
          id: this.checkoutOption.id
        });
        this.$store.commit("removeCheckoutOption", this.checkoutOption.id);
        this.$emit("clearSelected");
      } catch (e) {
        console.log("Error: ", e);
        this.error = "An error occurred.";
      }
    }
  },
  mounted() {},
  watch: {
    checkoutOption: {
      deep: true,
      handler(newVal, oldVal) {
        console.log("hey");
        this.applicableNodeTypes = this.initializeNodeTypes();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-option-form {
  label {
    display: block;
  }

  .form-group {
    margin-bottom: 20px;
  }

  .button-row {
    display: flex;
    justify-content: space-between;
  }

  .node-type-picker {
    border: 1px solid gray;
    padding: 10px;
  }

  .node-type-row {
    display: flex;
    flex-direction: row;
  }
}
</style>